import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import PromociokBase from "./PromociokBase";
import SlideshowContent from "./SlideshowContent";
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../WeboldalakTooltips';

class Promociok extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1"
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">Filmes promóciók</div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      Slideshow
                      <CustomTooltip text={getTooltip('slideshow')} id="slideshowTT" />
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({
                        active: this.state.activeTab === "2"
                      })}
                      onClick={() => {
                        this.toggle("2");
                      }}
                    >
                      Filmes promóciók
                      <CustomTooltip text={getTooltip('filmespromociok')} id="filmespromociokTT" />
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <SlideshowContent globals={this.props.globals} activeTab={this.state.activeTab} />
                  </TabPane>
                  <TabPane tabId="2">
                    <PromociokBase globals={this.props.globals} />
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Promociok;
